import { Link } from 'react-router';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useT } from '../i18n';
import './Page.css';

export function NotFound() {
  const t = useT();
  useDocumentTitle(t.titles.notFound);
  return (
    <div className="page-page">
      <h1>{t.notFound.title}</h1>
      <p className="page-lead">{t.notFound.body}</p>
      <Link to="/" className="btn">
        {t.notFound.back}
      </Link>
    </div>
  );
}
